import React from "react";
import {Label,Dropdown, Menu } from 'semantic-ui-react'
import { Button } from 'primereact/button';

import "semantic-ui-css/semantic.css";
//import "../../semantic-TicSoft.css";

export  const Tab = ({name, label, onClick, active, index, onAfterDeleteTab, onCloseClick}) => {
    
    let res = <></>
    if (name.includes ('Init') || name.includes ('init')){

        res = <Menu.Item name={name} //content={label} 
          active={active} onClick={() => onClick(name)} >
                {
                   <span>{label}</span>
                }
                </Menu.Item>
    }

    else{

        res = <Menu.Item name={name} //content={label} 
          active={active} onClick={() => onClick(name)} >
                {
                    <><Button icon="pi pi-times" 
                      className="p-button-rounded p-button-danger p-button-text" aria-label="Cancel" onClick={()=>{if(onAfterDeleteTab!== undefined) onAfterDeleteTab(name)  } } />
                    <span>{label}</span></>
                }
                </Menu.Item>
    }    

    return res;
    
};

export  const TabMultiple = (props) => {
    const {tabs, currentTab, onTabClick, onAfterDeleteTab, onSelectedFromMenu, ...otherProps} = props;

     return (<Menu.Item >
                {
                    <Dropdown key="DDOtros" item text="Otros">
                    <Dropdown.Menu key="menuOtros" >
                      {tabs.map((tabInfo,index)=>
                        <Dropdown.Item key={index} name = {tabInfo.name} onClick={() => onSelectedFromMenu(tabInfo.name)}>{tabInfo.label}</Dropdown.Item>
                      )}
                      
                    </Dropdown.Menu>
                  </Dropdown>
                }
                </Menu.Item>);
    
};


//<Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text" aria-label="Cancel" />
//        {label}<Label>15</Label>
export default Tab;
